import { Component, Inject, OnInit, ViewContainerRef } from '@angular/core';
import { UsuarioService } from '@app/services/usuario.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ValidaSenha } from '@app/utils/valida-senha';

@Component({
  selector: 'app-alterar-senha',
  templateUrl: './alterar-senha.component.html'
})
export class AlterarSenhaComponent {

  senhaAtual = '';
  novaSenha = '';
  repetirSenha = '';
  btnHabilitado = true;
  validadorSenha = ValidaSenha


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private usuarioService: UsuarioService,
    @Inject(ToastrService) public toastr: ToastrService
  ) { }

  alteraSenha() {

    if (this.senhaAtual === '') {
      this.toastr.error('Informe a Senha Atual');
      return;
    }

    const mensagemErrosSenha = this.validadorSenha.obterRequisitosNaoAtendidos(this.novaSenha);
    if (mensagemErrosSenha !== '') {
      this.toastr.error(mensagemErrosSenha, 'Erro na Validação da Senha');
      return;
    }

    if (this.novaSenha !== this.repetirSenha) {
      this.toastr.error('Os campos Nova Senha e Repetir Nova Senha não conferem');
      return;
    }

    this.btnHabilitado = false;

    this.usuarioService.alterarSenha(this.senhaAtual, this.novaSenha).toPromise().then(() => {
      // this.senhaAtual = "";
      // this.novaSenha = "";
      // this.repetirSenha = "";
      this.toastr.success('Senha alterada com sucesso!');
      setTimeout(() => {
        this.router.navigate(['dashboard']);
      }, 2000);
    },
      data => {
        this.btnHabilitado = true;
        this.toastr.error(data.errors[0]);
      });
  }

}
